// extracted by mini-css-extract-plugin
export var circle = "_3y-2";
export var icon = "_3y-a";
export var iconHighlight = "_3y-0";
export var lg = "_3y-8";
export var md = "_3y-7";
export var outline = "_3y-4";
export var sm = "_3y-6";
export var square = "_3y-1";
export var xl = "_3y-9";
export var xs = "_3y-5";
export var xxs = "_3y-3";